const initialState = {
  index: [],
  selected: [],
  data: {},
};

const ContentAd = (state = initialState, action) => {
  switch (action.type) {
    case "CONTENT_AD_INDEX":
      return { ...state, index: action.payload.index };
    case "CONTENT_AD_SELECTED":
      return { ...state, selected: action.payload.selected };
    case "CONTENT_AD_DATA":
      return { ...state, data: action.payload.data };
    case "CONTENT_AD_RESET":
      return initialState;
    default:
      return state;
  }
};

export default ContentAd;
